import { FC, useState } from 'react';
import {
  BooleanFilter,
  WbCard,
  WbCardContent,
  WbResponsiveTableToolbar,
  WbTooltip,
} from '@agilelab/plugin-wb-platform';
import { useTheme } from '@material-ui/core';
import { Test } from '../../ControlPanel';
import { useReleaseDetailPageContext } from '../context/useReleaseDetailPageContext';
import { Deploy } from '../types';
import { ValidationTestDrawer } from '../ValidationTestDrawer/ValidationTestDrawer';
import { DeploymentHistoryTable } from './DeploymentHistoryTable';

export const DeploymentHistoryCard: FC = () => {
  const theme = useTheme();
  const {
    release,
    deploymentHistoryCurrentReleaseOnly: currentReleaseOnly,
    setDeploymentHistoryCurrentReleaseOnly: setCurrentReleaseOnly,
  } = useReleaseDetailPageContext();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDeploy, setSelectedDeploy] = useState<Deploy | undefined>(
    undefined,
  );
  const [localTest, setLocalTest] = useState<Test | undefined>(undefined);

  const handleValidationGatewayClick = (
    deploy: Deploy,
    _subPlanId: string | undefined,
    test: Test | undefined,
  ) => {
    setSelectedDeploy(deploy);
    setLocalTest(test);
    setDrawerOpen(true);
  };

  return (
    <>
      <WbCard cardStyle={{ display: 'block' }}>
        <WbCardContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
          }}
        >
          <WbResponsiveTableToolbar title="Deployment History Filters">
            <WbResponsiveTableToolbar.Filters>
              <WbTooltip
                title={`When this filter is on, only deployments belonging to the release v${release.metadata.version} will be shown. When it is off, all deployments will be shown.`}
              >
                <div>
                  <BooleanFilter
                    field={`Release v${release.metadata.version}`}
                    value={currentReleaseOnly}
                    onChange={value => setCurrentReleaseOnly(Boolean(value))}
                  />
                </div>
              </WbTooltip>
            </WbResponsiveTableToolbar.Filters>
          </WbResponsiveTableToolbar>
          <DeploymentHistoryTable
            currentReleaseOnly={currentReleaseOnly}
            onValidationGatewayClick={handleValidationGatewayClick}
          />
        </WbCardContent>
      </WbCard>

      <ValidationTestDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        tests={{ loading: false, value: { test: localTest } }}
        version={selectedDeploy?.version}
        projectName={
          release.metadata.projectName ?? release.metadata.dataProductName
        }
      />
    </>
  );
};
